import React from 'react';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import { Select } from 'antd';
import { useAvailableStagesQuery } from '../../../../api/availableStages';
import { roomStageIdsMap } from '../../../../../../constants/room/lifeCycle';

const SelectStage = ({ value, onChange }) => {
  const { data, isFetching, refetch } = useAvailableStagesQuery({
    params: { stageId: roomStageIdsMap.acceptance },
  });

  const stages = getStages(data);
  const options = Array.isArray(stages) ? stages : [];

  return (
    <FetchDataWrapper
      data={stages}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg={
        data?.message ?? 'Не удалось загрузить список доступных стадий'
      }
    >
      <Select value={value} onChange={onChange} style={{ width: '100%' }}>
        {options.map((option) => (
          <Select.Option
            key={option.id}
            value={option.id}
            disabled={!option.available}
          >
            {option.name}
          </Select.Option>
        ))}
      </Select>
    </FetchDataWrapper>
  );
};

export default SelectStage;

function getStages(data) {
  if (!data || data === 'Error') {
    return data;
  }

  if (!data.success) {
    return 'Error';
  }

  return data.stagesAddressLifeCycleWithAvailability;
}
